import { boardComitee } from "../../data/DataAboutManagement";
import { ProfileCard } from "../UserInterface/ProfileCard";
import LayoutCenter from "../UserInterface/LayoutCenter";
import Description from "../UserInterface/Description";

const AboutProfile = () => {
  return (
    <>
      <div className="profile-wrapper">
        <LayoutCenter column>
          <div className="title">Manajemen</div>
          {boardComitee.map((data, key) => (
            <div key={key}>
              <Description
                fontSize="16px"
                fontWeight="bold"
                font="Roboto"
                text={data.title}
                margin="35px 0 19px 0"
              ></Description>
              <div
                className={
                  data.title === "Direksi" ? "profile-direksi" : "profile"
                }
              >
                {data.data.map((profile, key) => (
                  <ProfileCard
                    key={key}
                    title={profile.name}
                    subtitle={profile.position}
                  ></ProfileCard>
                ))}
              </div>
            </div>
          ))}
        </LayoutCenter>
      </div>
      <style jsx>{`
        .profile {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
        .profile-direksi {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          grid-template-columns: 1fr 1fr 1fr;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
        }
        .profile-wrapper {
          display: flex;
          justify-content: center;
          background-color: var(--color-white-soft);
        }
        @media only screen and (max-width: 1135px) {
          .profile-direksi {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }
        @media only screen and (max-width: 960px) {
          .profile-direksi {
            justify-content: center;
          }
        }
        @media only screen and (max-width: 770px) {
          .profile {
            grid-template-columns: 1fr;
          }
          .profile-direksi {
            flex-direction: column;
          }
        }
        @media only screen and (max-width: 600px) {
          .title {
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default AboutProfile;
